import React from 'react'

type Props = {
  bottomRef: React.Ref<HTMLDivElement>
}

const AnchorBottom: React.FC<Props> = ({ bottomRef }) => {
  return <div ref={bottomRef}></div>
}

export { AnchorBottom }
